import script from "./ArrowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArrowButton.vue?vue&type=script&setup=true&lang=ts"

import "./ArrowButton.vue?vue&type=style&index=0&id=314b01e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-314b01e6"]])

export default __exports__